import { RegisterOptions, UseFormRegister } from 'react-hook-form';

type HiddenInputProps = {
  name: string;
  index: number;
  value: string | number | readonly string[];
  register: UseFormRegister<any>;
  validation?: RegisterOptions;
};

// The following component is an example of your existing Input Component
export const Hidden = ({ name, index, value = '', register }: HiddenInputProps) => {
  return (
    <div className="hidden">
      <input
        id={`${name}-${index}`}
        className={'cmp-form-hidden'}
        type="hidden"
        {...register(name)}
        value={value}
      />
    </div>
  );
};
